import { render } from "./permissionSetting.vue?vue&type=template&id=b8c5d478"
import script from "./permissionSetting.vue?vue&type=script&lang=js"
export * from "./permissionSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__